import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../../i18n";
import { EASE } from "../../lib/site";
import { FeaturedProject } from "./FeaturedProject";
import { Reveal, SectionLabel } from "./Reveal";

const IMAGES = [
  ["/img/etsy2.jpg", "/img/etsy3.jpg", "/img/etsy4.jpg"],
  ["/img/cal2.jpg", "/img/cal1.jpg", "/img/cal3.jpg", "/img/cal4.jpg", "/img/cal5.jpg"],
];

export const Projects = () => {
  const { t } = useI18n();
  const p = t.projects;
  return (
    <section id="projects" data-testid="projects-section" className="bg-alabaster">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:px-12 lg:py-36">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal><SectionLabel>{p.label}</SectionLabel></Reveal>
            <Reveal delay={0.1}><h2 className="mt-6 font-serif text-5xl leading-[1] text-ink sm:text-6xl lg:text-7xl">{p.title}</h2></Reveal>
          </div>
          <Reveal delay={0.2} className="self-end lg:col-span-5"><p className="text-base leading-relaxed text-body-ink">{p.intro}</p></Reveal>
        </div>
        <div className="mt-20 space-y-28 lg:space-y-36">
          {p.featured.map((f, i) => <FeaturedProject key={i} p={f} index={i} images={IMAGES[i]} />)}
        </div>
        <Reveal className="mt-28 font-mono text-xs uppercase tracking-[0.28em] text-muted-ink">{p.moreLabel}</Reveal>
        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2">
          {p.more.map((m, i) => (
            <motion.div
              key={m.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
              data-testid={`more-project-${i}`}
              className="group relative overflow-hidden rounded-3xl border border-ink/10 bg-white p-8 transition-colors duration-500 hover:border-ink"
            >
              <span className="absolute inset-x-0 bottom-0 h-0 bg-ink transition-[height] duration-500 ease-out group-hover:h-full" />
              <div className="relative transition-colors duration-500 group-hover:text-paper">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-terra group-hover:text-[#E7C27D]">{m.tag}</span>
                  <ArrowUpRight className="h-5 w-5 transition-transform duration-500 group-hover:rotate-45" />
                </div>
                <h3 className="mt-8 font-serif text-2xl sm:text-3xl">{m.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-ink transition-colors duration-500 group-hover:text-paper/80">{m.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
